import { render, staticRenderFns } from "./TaRightIntroScreen.vue?vue&type=template&id=551185d4&scoped=true&"
import script from "./TaRightIntroScreen.vue?vue&type=script&lang=js&"
export * from "./TaRightIntroScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551185d4",
  null
  
)

export default component.exports